import React from "react"
import { connect } from "react-redux"

import PropTypes from "prop-types"

import { datumHeaderCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"
import { extractIdFromSheetKey } from "app/static/frontend/sheets/selectors/sheet-selectors"
// action creators
import {
    clearFilter,
    editSheet,
    patchSheet,
    toggleDatumColumnIsHiddenOnPublic,
} from "app/static/frontend/sheets/sheet-action-creators"

// components
import AddColumnButton from "app/static/frontend/sheets/components/AddColumnButton"
import ClearFilterButton from "app/static/frontend/sheets/components/ClearFilterButton"
import ColumnSearchTrigger from "app/static/frontend/sheets/components/ColumnSearchTrigger"
import ResizeRowsTrigger from "app/static/frontend/sheets/components/ResizeRowsTrigger"
import HideColumnTrigger from "app/static/frontend/sheets/components/HideColumnTrigger"
import Tooltip from "app/static/frontend/components/Tooltip"

// constants
import sheetConstants from "app/static/frontend/sheets/constants"

// styles
import "app/static/stylus/sheet.styl"

// Component to render the table header over the datum column (The second column in
// desktop mode (for example the column that says Officials for Person sheets ))
export const DatumHeaderCell = ({
    canAddColumns,
    canHideColumns,
    canResizeRows,
    dataType,
    datumHeaderTitle,
    datumCellStyles,
    id,
    isResourceTable,
    loading,
    tooltipText,
    rowHeightFactor,
    searching,
    sheetId,
    shouldShowDatumColumn,
    ...props
}) => {
    // this component is responsible for rendering the search component for the column
    const searchTrigger = () => (
        <ColumnSearchTrigger
            canSearch
            columnIndex={sheetConstants.DATUM_COLUMN_INDEX} // the columnIndex is a constant here
            id={id}
        />
    )

    return (
        <div className="datum-header-cell-inner-wrapper">
            <span className="column-name">
                <Tooltip label={tooltipText}>
                    <div className="datum-cell-title">{datumHeaderTitle}</div>
                </Tooltip>
            </span>
            <span className="active-column-options">
                {searching && searchTrigger()}
                {searching && (
                    <ClearFilterButton
                        dataCy="datum-column-clear-filter"
                        id={id}
                        clearFilter={props.clearFilter}
                        columnIndex={sheetConstants.DATUM_COLUMN_INDEX}
                    />
                )}
            </span>
            <div className="column-options" data-cy="datum-column" style={datumCellStyles.columnOptions}>
                <div className="column-triangle" />
                <div className="column-icons" style={datumCellStyles.columnIcons}>
                    {canHideColumns && (
                        <HideColumnTrigger
                            columnId={undefined}
                            handleHideColumn={props.toggleDatumColumnIsHiddenOnPublic}
                            isHidden={!shouldShowDatumColumn}
                            sheetKey={id}
                        />
                    )}
                    {canResizeRows && (
                        <ResizeRowsTrigger
                            editSheet={props.editSheet}
                            id={id}
                            loading={loading}
                            patchSheet={props.patchSheet}
                            rowHeightFactor={rowHeightFactor}
                        />
                    )}

                    {searchTrigger()}
                    {canAddColumns && (
                        <AddColumnButton
                            sheetId={extractIdFromSheetKey(sheetId)}
                            columnIndex={sheetConstants.DATUM_COLUMN_INDEX}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

DatumHeaderCell.propTypes = {
    canAddColumns: PropTypes.bool.isRequired,
    canHideColumns: PropTypes.bool.isRequired,
    canResizeRows: PropTypes.bool.isRequired,
    clearFilter: PropTypes.func.isRequired,
    datumCellStyles: PropTypes.object,
    editSheet: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    patchSheet: PropTypes.func.isRequired,
    searching: PropTypes.bool.isRequired,
    toggleColumnIsHiddenOnPublic: PropTypes.func.isRequired,
}

DatumHeaderCell.defaultProps = {
    // these are passed by the parent component, so just make sure there is something defined
    datumCellStyles: {
        columnIcons: {
            width: "101px",
        },
        columnOptions: {
            right: "-100px",
        },
    },
}

export default connect((state, props) => datumHeaderCellConnection(state, props), {
    editSheet,
    patchSheet,
    clearFilter,
    toggleDatumColumnIsHiddenOnPublic,
})(DatumHeaderCell)
